export default __webpack_public_path__ + "static/banner-cats-214831425fece25fd028a955a7f261c7.png";